import {
  Card,
  CardHeader,
  CardContent,
  Grid,
  ButtonBase,
  Box,
  Typography,
} from '@mui/material';
import {
  Add,
  CalendarMonth,
  EventBusy,
  ImportExport,
  Assessment,
  People,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useFeatureAccess } from '@/hooks/useFeatureAccess';

export function QuickActions() {
  const navigate = useNavigate();
  const {
    canEditTimetable,
    canViewAbsences,
    canUseImportExport,
    canViewReports,
    canViewMasterData,
  } = useFeatureAccess();

  const actions = [
    {
      label: 'Create Timetable',
      icon: <Add />,
      onClick: () => navigate('/app/timetable'),
      show: canEditTimetable,
      color: 'primary' as const,
      subtitle: 'New schedule',
    },
    {
      label: 'View Timetable',
      icon: <CalendarMonth />,
      onClick: () => navigate('/app/timetable'),
      show: canEditTimetable,
      color: 'secondary' as const,
      subtitle: 'Current week',
    },
    {
      label: 'Record Absence',
      icon: <EventBusy />,
      onClick: () => navigate('/app/absences'),
      show: canViewAbsences,
      color: 'warning' as const,
      subtitle: 'Log & assign sub',
    },
    {
      label: 'Import Data',
      icon: <ImportExport />,
      onClick: () => navigate('/app/import-export'),
      show: canUseImportExport,
      color: 'info' as const,
      subtitle: 'CSV / Excel',
    },
    {
      label: 'View Reports',
      icon: <Assessment />,
      onClick: () => navigate('/app/reports'),
      show: canViewReports,
      color: 'success' as const,
      subtitle: 'Analytics',
    },
    {
      label: 'Manage Teachers',
      icon: <People />,
      onClick: () => navigate('/app/master-data'),
      show: canViewMasterData,
      color: 'secondary' as const,
      subtitle: 'Roles & schedules',
    },
  ].filter((action) => action.show);

  return (
    <Card>
      <CardHeader title="Quick Actions" />
      <CardContent>
        <Grid container spacing={2}>
          {actions.map((action) => (
            <Grid item xs={12} sm={6} md={4} key={action.label}>
              <ButtonBase
                onClick={action.onClick}
                sx={{
                  width: '100%',
                  p: 2,
                  borderRadius: 2.5,
                  border: '1px solid',
                  borderColor: 'divider',
                  bgcolor: 'background.paper',
                  textAlign: 'left',
                  justifyContent: 'flex-start',
                  transition: 'all 0.18s ease',
                  '&:hover': {
                    borderColor: `${action.color}.main`,
                    transform: 'translateY(-1px)',
                    boxShadow: '0 6px 16px rgba(15, 23, 42, 0.08)',
                  },
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.25 }}>
                  <Box
                    sx={{
                      width: 34,
                      height: 34,
                      borderRadius: 1.5,
                      display: 'grid',
                      placeItems: 'center',
                      bgcolor: `${action.color}.light`,
                      color: `${action.color}.main`,
                      flexShrink: 0,
                    }}
                  >
                    {action.icon}
                  </Box>
                  <Box>
                    <Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
                      {action.label}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {action.subtitle}
                    </Typography>
                  </Box>
                </Box>
              </ButtonBase>
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
}
